import React, { useEffect, useState, useCallback } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const brl = (v: any, d = 2) => `R$ ${Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: d, maximumFractionDigits: d })}`
const dataBR = (iso: string | null) => (iso ? iso.split("-").reverse().join("/") : "—")
const mesBR = (ciclo: string) => { const [a, m] = ciclo.split("-"); return `${m}/${a}` }
const erroMsg = (e: any) => e?.response?.data?.erro || "Erro ao falar com o servidor"
const num = (v: any) => Number(v || 0)

const ABAS = [
  { id: "clientes", label: "🏢 Clientes" },
  { id: "consumo", label: "📊 Consumo" },
  { id: "precos", label: "💲 Preços e parâmetros" },
  { id: "fechamento", label: "🧾 Fechamento" },
]

const th = { padding: "10px 14px", textAlign: "left" as const, fontSize: 11, color: "#64748b", fontWeight: 600, textTransform: "uppercase" as const }
const td = { padding: "10px 14px", fontSize: 12 }

function Selo({ cor, fundo, children }: any) {
  return <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 10, background: fundo, color: cor, whiteSpace: "nowrap" }}>{children}</span>
}

export default function IAAdmin() {
  const [aba, setAba] = useState("clientes")

  // ---------- clientes ----------
  const [ciclo, setCiclo] = useState("")
  const [clientes, setClientes] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState<any>(null)
  const [form, setForm] = useState<any>({})
  const [salvando, setSalvando] = useState(false)

  const carregarClientes = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/ia/admin/clientes`)
      setCiclo(r.data.ciclo); setClientes(r.data.clientes)
    } catch (e: any) { alert(erroMsg(e)) } finally { setLoading(false) }
  }, [])

  const abrirModal = (c: any) => {
    setModal(c)
    setForm({
      ativo: !!c.ativo, credito: String(num(c.credito_mensal_brl)),
      margemPct: c.margem == null ? "" : String(Math.round(num(c.margem) * 10000) / 100),
      permite_excedente: c.permite_excedente !== false,
      teto: c.teto_excedente_brl == null ? "" : String(num(c.teto_excedente_brl)),
      fator: String(num(c.fator_excedente) || 1),
      testeDias: "", testeLimite: c.teste_limite_brl == null ? "" : String(num(c.teste_limite_brl)),
      encerrarTeste: false, observacao: c.observacao || "",
    })
  }

  const salvarCliente = async () => {
    if (!modal) return
    const margem = form.margemPct === "" ? null : Number(form.margemPct) / 100
    if (margem !== null && (isNaN(margem) || margem < 0 || margem >= 0.95)) return alert("Margem deve ficar entre 0% e 94%")
    if (isNaN(Number(form.credito)) || Number(form.credito) < 0) return alert("Pacote mensal inválido")
    const body: any = {
      ativo: form.ativo, credito_mensal_brl: Number(form.credito || 0), margem,
      permite_excedente: form.permite_excedente,
      teto_excedente_brl: form.teto === "" ? null : Number(form.teto),
      fator_excedente: Number(form.fator || 1),
      teste_limite_brl: form.testeLimite === "" ? null : Number(form.testeLimite),
      observacao: form.observacao || null,
    }
    if (form.encerrarTeste) body.encerrar_teste = true
    else if (form.testeDias !== "" && Number(form.testeDias) > 0) body.iniciar_teste_dias = Number(form.testeDias)
    setSalvando(true)
    try {
      await axios.put(`${API}/ia/admin/clientes/${modal.cliente_id}`, body)
      setModal(null); await carregarClientes()
    } catch (e: any) { alert(erroMsg(e)) } finally { setSalvando(false) }
  }

  // ---------- consumo ----------
  const [filtroCliente, setFiltroCliente] = useState("")
  const [filtroMes, setFiltroMes] = useState("")
  const [uso, setUso] = useState<any>(null)

  const carregarUso = useCallback(async () => {
    try {
      const q = new URLSearchParams()
      if (filtroMes) q.set("ciclo", filtroMes)
      if (filtroCliente) q.set("cliente_id", filtroCliente)
      const r = await axios.get(`${API}/ia/admin/uso?${q.toString()}`)
      setUso(r.data)
    } catch (e: any) { alert(erroMsg(e)) }
  }, [filtroMes, filtroCliente])

  // ---------- precos e parametros ----------
  const [params, setParams] = useState<any>(null)
  const [pForm, setPForm] = useState<any>({ cotacao: "", margemPct: "" })
  const [modelos, setModelos] = useState<any[]>([])
  const [mEdit, setMEdit] = useState<any>({})
  const [novo, setNovo] = useState<any>({ modelo: "", entrada: "", saida: "" })

  const carregarPrecos = useCallback(async () => {
    try {
      const [p, m] = await Promise.all([axios.get(`${API}/ia/admin/parametros`), axios.get(`${API}/ia/admin/modelos`)])
      setParams(p.data)
      setPForm({ cotacao: String(num(p.data?.cotacao_usd_brl)), margemPct: String(Math.round(num(p.data?.margem_padrao) * 10000) / 100) })
      setModelos(m.data)
      const ed: any = {}
      m.data.forEach((x: any) => { ed[x.modelo] = { entrada: String(num(x.entrada_usd_mtok)), saida: String(num(x.saida_usd_mtok)) } })
      setMEdit(ed)
    } catch (e: any) { alert(erroMsg(e)) }
  }, [])

  const salvarParametros = async () => {
    try {
      await axios.put(`${API}/ia/admin/parametros`, { cotacao_usd_brl: Number(pForm.cotacao), margem_padrao: Number(pForm.margemPct) / 100 })
      alert("Parâmetros salvos"); carregarPrecos()
    } catch (e: any) { alert(erroMsg(e)) }
  }

  const salvarModelo = async (modelo: string, entrada: string, saida: string, extra: any = {}) => {
    try {
      await axios.put(`${API}/ia/admin/modelos/${modelo}`, { entrada_usd_mtok: Number(entrada), saida_usd_mtok: Number(saida), ...extra })
      alert(`Preço de ${modelo} salvo (vale a partir de hoje)`); carregarPrecos()
    } catch (e: any) { alert(erroMsg(e)) }
  }

  // ---------- fechamento ----------
  const [fech, setFech] = useState<any>({ ciclo_anterior: "", fechamentos: [] })
  const carregarFechamentos = useCallback(async () => {
    try { const r = await axios.get(`${API}/ia/admin/fechamentos`); setFech(r.data) } catch (e: any) { alert(erroMsg(e)) }
  }, [])
  const fecharMes = async () => {
    if (!fech.ciclo_anterior) return
    if (!window.confirm(`Fechar o mês ${mesBR(fech.ciclo_anterior)}? Isso calcula o excedente de cada cliente para a fatura.`)) return
    try {
      const r = await axios.post(`${API}/ia/admin/fechar`, { ciclo: fech.ciclo_anterior })
      alert(r.data.fechamentos_criados > 0 ? `${r.data.fechamentos_criados} fechamento(s) criado(s)` : "Esse mês já estava fechado")
      carregarFechamentos()
    } catch (e: any) { alert(erroMsg(e)) }
  }

  useEffect(() => { carregarClientes() }, [carregarClientes])
  useEffect(() => { if (aba === "consumo") carregarUso() }, [aba, carregarUso])
  useEffect(() => { if (aba === "precos") carregarPrecos() }, [aba, carregarPrecos])
  useEffect(() => { if (aba === "fechamento") carregarFechamentos() }, [aba, carregarFechamentos])

  // ---------- totais do topo ----------
  const soma = (campo: string) => clientes.reduce((s, c) => s + num(c[campo]), 0)
  const cards = [
    { label: "Clientes com IA ligada", valor: clientes.filter((c) => c.ativo).length, cor: "#22c55e", icone: "🤖" },
    { label: `Consumo cobrável (${ciclo ? mesBR(ciclo) : "mês"})`, valor: brl(soma("consumo_brl")), cor: "#0ea5e9", icone: "💰" },
    { label: "Excedente a faturar", valor: brl(soma("excedente_brl")), cor: "#f59e0b", icone: "📈" },
    { label: "Custo real no mês", valor: brl(soma("custo_real_brl")), cor: "#f87171", icone: "🧮" },
    { label: "Gasto em teste (grátis)", valor: brl(soma("consumo_teste_brl")), cor: "#8b5cf6", icone: "🧪" },
  ]

  const margemModal = modal ? (form.margemPct === "" ? num(modal.margem_efetiva) : Number(form.margemPct) / 100) : 0

  return (
    <div style={{ padding: 24, height: "100%", overflowY: "auto" }}>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700 }}>🤖 Inteligência Artificial — Plataforma</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>Ligue a IA por cliente, defina pacote, margem e teste, e acompanhe o consumo e o que vai para a fatura</p>
      </div>

      <div style={{ display: "flex", gap: 6, marginBottom: 18, flexWrap: "wrap" }}>
        {ABAS.map((a) => (
          <button key={a.id} className={aba === a.id ? "btn btn-primary" : "btn btn-ghost"} onClick={() => setAba(a.id)}>{a.label}</button>
        ))}
      </div>

      {/* ===================== CLIENTES ===================== */}
      {aba === "clientes" && (
        <>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(180px,1fr))", gap: 14, marginBottom: 20 }}>
            {cards.map((s, i) => (
              <div key={i} className="card" style={{ padding: "14px 16px" }}>
                <div style={{ fontSize: 22, marginBottom: 6 }}>{s.icone}</div>
                <div style={{ fontSize: 18, fontWeight: 700, color: s.cor }}>{s.valor}</div>
                <div style={{ fontSize: 11, color: "#64748b" }}>{s.label}</div>
              </div>
            ))}
          </div>

          <div className="card" style={{ padding: 0, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#0d1b2e" }}>
                  {["Empresa", "IA", "Pacote/mês", "Uso no mês", "Excedente", "Leituras", "Ações"].map((h) => <th key={h} style={th}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={7} style={{ padding: 24, textAlign: "center", color: "#64748b" }}>Carregando...</td></tr>
                ) : clientes.length === 0 ? (
                  <tr><td colSpan={7} style={{ padding: 24, textAlign: "center", color: "#64748b" }}>Nenhum cliente cadastrado</td></tr>
                ) : clientes.map((c) => {
                  const pctUso = c.percentual_usado
                  const corBarra = pctUso == null ? "#475569" : pctUso >= 100 ? "#ef4444" : pctUso >= 80 ? "#f59e0b" : "#22c55e"
                  return (
                    <tr key={c.cliente_id} style={{ borderBottom: "1px solid rgba(45,65,102,0.4)" }}>
                      <td style={td}><div style={{ fontWeight: 600, fontSize: 13 }}>{c.razao_social}</div>
                        {c.observacao && <div style={{ fontSize: 10, color: "#64748b" }}>{c.observacao}</div>}</td>
                      <td style={td}>
                        {!c.configurado ? <Selo cor="#64748b" fundo="#1e293b">Não configurada</Selo>
                          : !c.ativo ? <Selo cor="#f87171" fundo="#3b1010">Desligada</Selo>
                          : c.em_teste ? <Selo cor="#c4b5fd" fundo="#2e1065">🧪 Teste até {dataBR(c.teste_ate)}</Selo>
                          : <Selo cor="#4ade80" fundo="#14532d">✅ Ativa</Selo>}
                      </td>
                      <td style={{ ...td, color: "#22c55e", fontWeight: 600 }}>{c.configurado ? brl(c.credito_mensal_brl) : "—"}</td>
                      <td style={{ ...td, minWidth: 170 }}>
                        {c.em_teste ? (
                          <span style={{ color: "#c4b5fd" }}>{brl(c.consumo_teste_brl, 4)} em teste (grátis)</span>
                        ) : c.configurado && c.ativo ? (
                          <>
                            <div>{brl(c.consumo_brl, 4)}{num(c.credito_mensal_brl) > 0 && <span style={{ color: "#64748b" }}> de {brl(c.credito_mensal_brl)}</span>}</div>
                            {pctUso != null && (
                              <div style={{ height: 5, background: "#1e2f4a", borderRadius: 3, marginTop: 4 }}>
                                <div style={{ height: 5, width: `${Math.min(100, pctUso)}%`, background: corBarra, borderRadius: 3 }} />
                              </div>
                            )}
                          </>
                        ) : <span style={{ color: "#475569" }}>—</span>}
                      </td>
                      <td style={{ ...td, color: num(c.excedente_brl) > 0 ? "#f59e0b" : "#475569", fontWeight: num(c.excedente_brl) > 0 ? 600 : 400 }}>
                        {num(c.excedente_brl) > 0 ? brl(c.excedente_brl, 4) : "—"}
                      </td>
                      <td style={td}>{num(c.chamadas)}</td>
                      <td style={td}><button className="btn btn-ghost" style={{ padding: "4px 10px", fontSize: 11 }} onClick={() => abrirModal(c)}>⚙️ Configurar</button></td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ===================== CONSUMO ===================== */}
      {aba === "consumo" && (
        <>
          <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
            <div className="form-group" style={{ minWidth: 240 }}>
              <label>Cliente</label>
              <select value={filtroCliente} onChange={(e) => setFiltroCliente(e.target.value)}>
                <option value="">Todos os clientes</option>
                {clientes.map((c) => <option key={c.cliente_id} value={c.cliente_id}>{c.razao_social}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Mês</label>
              <input type="month" value={filtroMes || ciclo} onChange={(e) => setFiltroMes(e.target.value)} />
            </div>
          </div>

          {uso && (
            <>
              {uso.sem_preco > 0 && (
                <div className="card" style={{ padding: "10px 14px", marginBottom: 14, border: "1px solid #f59e0b", color: "#fbbf24", fontSize: 12 }}>
                  ⚠️ {uso.sem_preco} leitura(s) de um modelo <b>sem preço cadastrado</b>: os tokens foram gravados, mas o valor não foi calculado. Cadastre o preço na aba "Preços e parâmetros".
                </div>
              )}
              {[
                { titulo: "Por função", linhas: uso.por_funcao },
                { titulo: "Por modelo", linhas: uso.por_modelo },
                { titulo: "Por dia", linhas: uso.por_dia },
              ].map((bloco) => (
                <div key={bloco.titulo} style={{ marginBottom: 18 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#94a3b8", marginBottom: 8 }}>{bloco.titulo}</div>
                  <div className="card" style={{ padding: 0, overflow: "hidden" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead><tr style={{ background: "#0d1b2e" }}>
                        {[bloco.titulo.replace("Por ", ""), "Leituras", "Tokens (ent./saída)", "Custo real", "Valor ao cliente"].map((h) => <th key={h} style={th}>{h}</th>)}
                      </tr></thead>
                      <tbody>
                        {bloco.linhas.length === 0 ? (
                          <tr><td colSpan={5} style={{ padding: 16, textAlign: "center", color: "#64748b" }}>Sem consumo neste período</td></tr>
                        ) : bloco.linhas.map((l: any) => (
                          <tr key={l.chave} style={{ borderBottom: "1px solid rgba(45,65,102,0.4)" }}>
                            <td style={td}>{bloco.titulo === "Por dia" ? dataBR(l.chave) : l.chave}</td>
                            <td style={td}>{num(l.chamadas)}</td>
                            <td style={{ ...td, color: "#94a3b8" }}>{l.tokens_entrada != null ? `${num(l.tokens_entrada).toLocaleString("pt-BR")} / ${num(l.tokens_saida).toLocaleString("pt-BR")}` : "—"}</td>
                            <td style={{ ...td, color: "#f87171" }}>{brl(l.custo_brl, 4)}</td>
                            <td style={{ ...td, color: "#22c55e", fontWeight: 600 }}>{brl(l.preco_cliente_brl, 4)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
              <div className="card" style={{ padding: "12px 16px", fontSize: 12, color: "#94a3b8" }}>
                🧪 <b>Uso interno da plataforma</b> (testes seus, nunca cobrados): {num(uso.interno?.chamadas)} leitura(s), custo real {brl(uso.interno?.custo_brl, 4)}
              </div>
            </>
          )}
        </>
      )}

      {/* ===================== PRECOS E PARAMETROS ===================== */}
      {aba === "precos" && (
        <>
          <div className="card" style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>⚙️ Parâmetros gerais</div>
            <div className="form-grid">
              <div className="form-group">
                <label>Cotação do dólar (R$ por US$ 1)</label>
                <input type="number" step="0.0001" min="0" value={pForm.cotacao} onChange={(e) => setPForm({ ...pForm, cotacao: e.target.value })} />
                <div style={{ fontSize: 10, color: "#475569", marginTop: 3 }}>O custo da IA é cobrado em dólar. Atualize quando a cotação mudar muito.</div>
              </div>
              <div className="form-group">
                <label>Margem padrão (% do que o cliente paga que fica com você)</label>
                <input type="number" step="0.1" min="0" max="94" value={pForm.margemPct} onChange={(e) => setPForm({ ...pForm, margemPct: e.target.value })} />
                <div style={{ fontSize: 10, color: "#475569", marginTop: 3 }}>
                  Com {pForm.margemPct || 0}%: custo R$ 7,00 vira R$ {(7 / (1 - (Number(pForm.margemPct) || 0) / 100)).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} para o cliente.
                </div>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12 }}>
              <span style={{ fontSize: 11, color: "#475569" }}>{params?.atualizado_em ? `Atualizado em ${params.atualizado_em}` : ""}</span>
              <button className="btn btn-primary" onClick={salvarParametros}>💾 Salvar parâmetros</button>
            </div>
          </div>

          <div style={{ fontSize: 13, fontWeight: 700, color: "#94a3b8", marginBottom: 4 }}>Preço de cada modelo (US$ por 1 milhão de tokens)</div>
          <div style={{ fontSize: 11, color: "#64748b", marginBottom: 10 }}>
            Cada edição vale a partir de hoje. O que já foi gravado <b>não muda</b>. Confira os valores na tabela oficial da Anthropic.
          </div>
          <div className="card" style={{ padding: 0, overflow: "hidden", marginBottom: 14 }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#0d1b2e" }}>
                {["Modelo", "Entrada (US$)", "Saída (US$)", "Vigente desde", ""].map((h) => <th key={h} style={th}>{h}</th>)}
              </tr></thead>
              <tbody>
                {modelos.map((m) => (
                  <tr key={m.modelo} style={{ borderBottom: "1px solid rgba(45,65,102,0.4)" }}>
                    <td style={{ ...td, fontWeight: 600 }}>{m.modelo}</td>
                    <td style={td}><input type="number" step="0.01" min="0" style={{ width: 100 }} value={mEdit[m.modelo]?.entrada ?? ""}
                      onChange={(e) => setMEdit({ ...mEdit, [m.modelo]: { ...mEdit[m.modelo], entrada: e.target.value } })} /></td>
                    <td style={td}><input type="number" step="0.01" min="0" style={{ width: 100 }} value={mEdit[m.modelo]?.saida ?? ""}
                      onChange={(e) => setMEdit({ ...mEdit, [m.modelo]: { ...mEdit[m.modelo], saida: e.target.value } })} /></td>
                    <td style={{ ...td, color: "#94a3b8" }}>{dataBR(m.vigente_desde)}</td>
                    <td style={td}>
                      <button className="btn btn-ghost" style={{ padding: "4px 10px", fontSize: 11 }}
                        onClick={() => salvarModelo(m.modelo, mEdit[m.modelo]?.entrada, mEdit[m.modelo]?.saida, {
                          limite_prompt_longo: m.limite_prompt_longo, entrada_longo_usd_mtok: m.entrada_longo_usd_mtok, saida_longo_usd_mtok: m.saida_longo_usd_mtok })}>
                        💾 Salvar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="card">
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>➕ Cadastrar preço de um modelo novo</div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
              <div className="form-group" style={{ minWidth: 220 }}><label>Nome do modelo</label>
                <input value={novo.modelo} placeholder="ex.: claude-haiku-5-5" onChange={(e) => setNovo({ ...novo, modelo: e.target.value.trim() })} /></div>
              <div className="form-group"><label>Entrada (US$)</label>
                <input type="number" step="0.01" min="0" style={{ width: 110 }} value={novo.entrada} onChange={(e) => setNovo({ ...novo, entrada: e.target.value })} /></div>
              <div className="form-group"><label>Saída (US$)</label>
                <input type="number" step="0.01" min="0" style={{ width: 110 }} value={novo.saida} onChange={(e) => setNovo({ ...novo, saida: e.target.value })} /></div>
              <button className="btn btn-primary" onClick={async () => {
                if (!novo.modelo || novo.entrada === "" || novo.saida === "") return alert("Preencha o nome e os dois preços")
                await salvarModelo(novo.modelo, novo.entrada, novo.saida); setNovo({ modelo: "", entrada: "", saida: "" })
              }}>Cadastrar</button>
            </div>
          </div>
        </>
      )}

      {/* ===================== FECHAMENTO ===================== */}
      {aba === "fechamento" && (
        <>
          <div className="card" style={{ padding: "14px 16px", marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <div style={{ fontSize: 12, color: "#94a3b8", maxWidth: 560 }}>
              O fechamento calcula, para cada cliente, o consumo do mês, o pacote e o <b>excedente que vai na fatura</b>. Nunca apaga o consumo, e fechar duas vezes não duplica.
            </div>
            <button className="btn btn-primary" onClick={fecharMes} disabled={!fech.ciclo_anterior}>
              🧾 Fechar {fech.ciclo_anterior ? mesBR(fech.ciclo_anterior) : "mês anterior"}
            </button>
          </div>
          <div className="card" style={{ padding: 0, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#0d1b2e" }}>
                {["Mês", "Empresa", "Pacote", "Consumo", "Excedente (fatura)", "Custo real", "Leituras", "Fechado em"].map((h) => <th key={h} style={th}>{h}</th>)}
              </tr></thead>
              <tbody>
                {fech.fechamentos.length === 0 ? (
                  <tr><td colSpan={8} style={{ padding: 24, textAlign: "center", color: "#64748b" }}>Nenhum mês fechado ainda</td></tr>
                ) : fech.fechamentos.map((f: any) => (
                  <tr key={`${f.ciclo}-${f.cliente_id}`} style={{ borderBottom: "1px solid rgba(45,65,102,0.4)" }}>
                    <td style={{ ...td, fontWeight: 600 }}>{mesBR(f.ciclo)}</td>
                    <td style={td}>{f.razao_social}</td>
                    <td style={td}>{brl(f.credito_brl)}</td>
                    <td style={td}>{brl(f.consumo_brl, 4)}</td>
                    <td style={{ ...td, color: num(f.excedente_brl) > 0 ? "#f59e0b" : "#475569", fontWeight: 600 }}>{brl(f.excedente_brl, 4)}</td>
                    <td style={{ ...td, color: "#f87171" }}>{brl(f.custo_real_brl, 4)}</td>
                    <td style={td}>{num(f.chamadas)}</td>
                    <td style={{ ...td, color: "#64748b" }}>{f.fechado_em}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ===================== MODAL: CONFIGURAR CLIENTE ===================== */}
      {modal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div className="card" style={{ width: "100%", maxWidth: 580, maxHeight: "90vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <h3>⚙️ IA — {modal.razao_social}</h3>
              <button className="btn btn-ghost" style={{ padding: "4px 8px" }} onClick={() => setModal(null)}>✕</button>
            </div>
            <div style={{ fontSize: 11, color: "#64748b", marginBottom: 16 }}>
              {modal.em_teste ? `Em teste até ${dataBR(modal.teste_ate)} (${modal.teste_limite_brl == null ? "ilimitado" : `limite ${brl(modal.teste_limite_brl)}`}) — nada é cobrado` : "Sem período de teste ativo"}
            </div>

            <div className="form-grid">
              <div className="form-group full">
                <label>🤖 IA para esta empresa</label>
                <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                  {[{ v: true, l: "✅ Ligada" }, { v: false, l: "⛔ Desligada" }].map((op) => (
                    <div key={String(op.v)} onClick={() => setForm({ ...form, ativo: op.v })}
                      style={{ flex: 1, padding: "8px 12px", borderRadius: 8, cursor: "pointer", textAlign: "center", fontSize: 12,
                        border: `2px solid ${form.ativo === op.v ? (op.v ? "#22c55e" : "#ef4444") : "#2d4166"}`,
                        background: form.ativo === op.v ? (op.v ? "#0d2e1a" : "#2e1010") : "transparent",
                        color: form.ativo === op.v ? "#f1f5f9" : "#94a3b8" }}>{op.l}</div>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <label>💰 Pacote mensal (R$)</label>
                <input type="number" step="0.01" min="0" value={form.credito} onChange={(e) => setForm({ ...form, credito: e.target.value })} />
                <div style={{ fontSize: 10, color: "#475569", marginTop: 3 }}>Quanto de IA o cliente paga por mês. Renova todo dia 1º às 00:01.</div>
              </div>
              <div className="form-group">
                <label>📐 Margem (%)</label>
                <input type="number" step="0.1" min="0" max="94" value={form.margemPct} placeholder={`padrão (${Math.round(num(modal.margem_efetiva) * 1000) / 10}%)`}
                  onChange={(e) => setForm({ ...form, margemPct: e.target.value })} />
                <div style={{ fontSize: 10, color: "#475569", marginTop: 3 }}>
                  Cada R$ 1,00 de custo vira {brl(1 / (1 - (isNaN(margemModal) ? 0 : margemModal)))} para o cliente.
                </div>
              </div>

              <div className="form-group full">
                <label>📈 Passou do pacote?</label>
                <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                  {[{ v: true, l: "Continua usando — o excedente vai na fatura" }, { v: false, l: "Bloqueia até o mês seguinte" }].map((op) => (
                    <div key={String(op.v)} onClick={() => setForm({ ...form, permite_excedente: op.v })}
                      style={{ flex: 1, padding: "8px 10px", borderRadius: 8, cursor: "pointer", textAlign: "center", fontSize: 11,
                        border: `2px solid ${form.permite_excedente === op.v ? "#f59e0b" : "#2d4166"}`,
                        background: form.permite_excedente === op.v ? "#2e1f05" : "transparent",
                        color: form.permite_excedente === op.v ? "#fbbf24" : "#94a3b8" }}>{op.l}</div>
                  ))}
                </div>
              </div>
              {form.permite_excedente && (
                <>
                  <div className="form-group">
                    <label>🛡️ Teto do excedente (R$)</label>
                    <input type="number" step="0.01" min="0" value={form.teto} placeholder="sem teto" onChange={(e) => setForm({ ...form, teto: e.target.value })} />
                    <div style={{ fontSize: 10, color: "#475569", marginTop: 3 }}>Trava de segurança contra fatura-surpresa.</div>
                  </div>
                  <div className="form-group">
                    <label>✖️ Fator do excedente</label>
                    <input type="number" step="0.01" min="0.01" value={form.fator} onChange={(e) => setForm({ ...form, fator: e.target.value })} />
                    <div style={{ fontSize: 10, color: "#475569", marginTop: 3 }}>1 = mesmo preço do pacote; 1,5 = excedente 50% mais caro.</div>
                  </div>
                </>
              )}

              <div className="form-group full" style={{ borderTop: "1px solid #2d4166", paddingTop: 14, marginTop: 4 }}>
                <label>🧪 Período de teste (não cobra)</label>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end", marginTop: 4 }}>
                  <div>
                    <div style={{ fontSize: 10, color: "#64748b", marginBottom: 3 }}>Começar teste de quantos dias, a partir de hoje?</div>
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <input type="number" min="0" max="365" style={{ width: 90 }} value={form.testeDias} placeholder="0"
                        onChange={(e) => setForm({ ...form, testeDias: e.target.value, encerrarTeste: false })} />
                      <button className="btn btn-ghost" style={{ padding: "6px 10px", fontSize: 11 }} onClick={() => setForm({ ...form, testeDias: "30", encerrarTeste: false })}>30 dias</button>
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 10, color: "#64748b", marginBottom: 3 }}>Limite do teste (R$) — vazio = ilimitado</div>
                    <input type="number" step="0.01" min="0" style={{ width: 130 }} value={form.testeLimite} placeholder="ilimitado" onChange={(e) => setForm({ ...form, testeLimite: e.target.value })} />
                  </div>
                  {modal.teste_ate && (
                    <button className="btn btn-ghost" style={{ padding: "6px 10px", fontSize: 11, color: form.encerrarTeste ? "#fbbf24" : "#f87171" }}
                      onClick={() => setForm({ ...form, encerrarTeste: !form.encerrarTeste, testeDias: "" })}>
                      {form.encerrarTeste ? "✔ Vai encerrar o teste ao salvar" : "🛑 Encerrar teste agora"}
                    </button>
                  )}
                </div>
              </div>

              <div className="form-group full">
                <label>📝 Observação</label>
                <input value={form.observacao} placeholder="ex.: cliente piloto, teste até virar plano" onChange={(e) => setForm({ ...form, observacao: e.target.value })} />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 18 }}>
              <button className="btn btn-ghost" onClick={() => setModal(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvarCliente} disabled={salvando}>{salvando ? "Salvando..." : "💾 Salvar"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
